import React from "react"
import { Card } from "reactstrap"
import ShowThumbnail from "./Thumbnail"
import ExpandableText from "./ExpandText"
import Spinners from "components/Common/Spinner"
import moment from "moment"

const Student = ({ filteredNotifications, Loading }) => {
  const dates = new Set()

  const renderDate = isoDateString => {
    const date = new Date(isoDateString)
    const day = String(date.getUTCDate()).padStart(2, "0")
    const month = String(date.getUTCMonth() + 1).padStart(2, "0")
    const year = date.getUTCFullYear()
    const formattedDate = `${day}-${month}-${year}`

    if (dates.has(formattedDate)) return null
    dates.add(formattedDate)

    return (
      <div className="my-2 d-flex justify-content-center align-items-center">
        <div className="p-2 mb-1 bg-white d-inline-block border rounded-4 shadow">
          {formattedDate}
        </div>
      </div>
    )
  }

  return (
    <>
      {Loading ? (
        <Spinners />
      ) : (
        filteredNotifications.map((Notification, index) => {
          const createdDate = moment(Notification.created)
          const dateNum = createdDate.isValid()
            ? createdDate.format("DD/MM/YYYY")
            : null

          if (!dateNum) {
            console.warn("Invalid date found:", Notification.created)
            return null
          }

          const NotificationType =
            Notification.an_type === 1 || Notification.an_type === 6
              ? 1
              : Notification.an_type === 2
              ? 2
              : [3, 7, 8, 11, 21, 100, 101].includes(Notification.an_type)
              ? 3
              : ""

          return (
            <div className="mt-8" key={index}>
              {renderDate(Notification.created)}
              <Card
                className={`p-2 mx-auto border ${
                  NotificationType === 1
                    ? "Homework-card"
                    : NotificationType === 2
                    ? "announcement-card"
                    : NotificationType === 3
                    ? "studentSpecific-card"
                    : "bg-light"
                } rounded-3`}
              >
                <ShowThumbnail Notification={Notification} />
                <ExpandableText
                  descriptionLength={370}
                  text={Notification}
                  NotificationType={NotificationType}
                />
              </Card>
            </div>
          )
        })
      )}
    </>
  )
}

export default Student
